import {
  REQUEST_TARGETS,
  RequestModel,
} from '@/app/request/RequestModel';
import axios from 'axios';
import { axiosBitrix } from '@/shared/plugins/axiosBitrix';
import { axiosLander } from '@/shared/plugins/axiosLander';

const targetsMap: any = {
  [REQUEST_TARGETS.LANDER]: axiosLander,
  [REQUEST_TARGETS.SVC]: axios,
  [REQUEST_TARGETS.BITRIX]: axiosBitrix,
};

/**
 * @deprecated use /app/utils/request.ts
 */
export async function request<T extends any>(request: RequestModel): Promise<T> {
  const axiosInstance = targetsMap[request.target];

  const { data } = await axiosInstance.request({
    params: request.params,
    headers: request.headers,
    data: request.body,
    method: request.method,
    url: request.url,
  });

  return data;
}
